import React, { Component } from 'react';
import _ from 'lodash';
import { Grid, Header } from 'semantic-grab-ui/src';

export default class MintActionForm extends Component {
  constructor(props) {
    super(props);
    const { model, currentNode, subActionIndex } = props;
    _.set(model, `nodes.${currentNode}.data.${subActionIndex}.meta`, {});
    props.onModelChange(model);
  }

  render() {
    return (
      <Header.Subheader as={Grid.Column}>
        Project hashbrown
      </Header.Subheader>
    );
  }
}
